





















































































// Vue
import Vue from "vue";
// Vuex
import { mapActions } from "vuex";
// Vuelidate
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// Models
import { ClientModel, ClientClient, DaysOfWeek } from "@/core/api/apiClient";

import AdminService from "@/views/admin/Admin.service";

export default Vue.extend({
  name: "CreateSystemClientDialog",
  mixins: [validationMixin],
  props: ["nextIndex"],

  data() {
    return {
      dialog: false,
      isValid: false,
      isLoading: false,

      myFile: undefined,
      Name: "",
      CompanyLogo: "",
      MainThemeColor: "#10207C"
    };
  },

  validations: {
    Name: { required },
    MainThemeColor: { required }
  },

  methods: {
    ...mapActions("clients", {
      setClient: "setClient"
    }),

    submit(): void {
      const newSystemClient: ClientModel = new ClientModel({
        clientId: "",
        name: this.Name,
        mainThemeColor: this.MainThemeColor,
        mainThemeTextColor: "#FFFFFF", // ! Do NOT remove this - needed for the mobile app.
        jobSchedulerTimeIntervals: 30,
        workingDays: Object.values(DaysOfWeek)
      });

      this.createClient(newSystemClient, this.myFile);
    },

    async createClient(newClient: ClientModel, logo: File | undefined): Promise<void> {
      this.isLoading = true;
      // Create the new SystemClient.
      await this.setClient({ newClient: newClient, logo: logo }).then(() => {
        this.$emit("refresh-clients");
        this.isLoading = false;
        this.close();
      });
    },

    close(): void {
      this.Name = "";
      this.MainThemeColor = "#10207C";

      this.$v.$reset();
      this.dialog = false;
    }
  },

  computed: {
    NameErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.Name.required && errors.push("Name is required");
      return errors;
    }
  }
});
